import React, {useState} from 'react'
import Button from 'lib/ui/Button'
import {JsonSave} from 'lib/JsonUpdateProvider'
import {NLPurchasePageTemplate} from 'Event/Marketplace/nl-purchase-page'
import {generateHashId} from 'lib/crypto/hash'
import {createRowBlock} from 'Event/Marketplace/Block/RowBlock/create-row-block'
import {DarkThemeProvider} from 'lib/ui/theme/ThemeProvider'
import Dialog, {DialogBody} from 'lib/ui/Dialog'
import {DialogTitle} from '@material-ui/core'
import {RowBlock} from 'Event/Marketplace/Block/RowBlock'
import {onUnknownChangeHandler} from 'lib/dom'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import styled from 'styled-components'

interface AddRowDialogProps {
  updateTemplate: JsonSave<NLPurchasePageTemplate>
  open: boolean
  onClose: () => void
}

export default function AddRowDialog(props: AddRowDialogProps) {
  const {updateTemplate, open, onClose} = props
  const [numColumns, setNumColumns] = useState<RowBlock['numColumns']>(1)

  const addRow = () => {
    generateHashId([
      'row',
      Date.now().toString(),
      Math.random().toString(),
    ]).then((id) => {
      updateTemplate({
        blocks: {
          [id]: createRowBlock(numColumns),
        },
      })
      onClose()
    })
  }

  return (
    <DarkThemeProvider>
      <Dialog open={open} onClose={onClose} expandable disableEnforceFocus>
        <DialogTitle>Add Row</DialogTitle>
        <StyledDialogBody>
          <Select
            fullWidth
            label="numColumns"
            value={numColumns}
            onChange={onUnknownChangeHandler((val: string) =>
              setNumColumns(parseInt(val) as RowBlock['numColumns']),
            )}
          >
            <Option value="1">1</Option>
            <Option value="2">2</Option>
            <Option value="3">3</Option>
            <Option value="4">4</Option>
            <Option value="5">5</Option>
            <Option value="6">6</Option>
            <Option value="7">7</Option>
            <Option value="8">8</Option>
            <Option value="9">9</Option>
            <Option value="10">10</Option>
            <Option value="11">11</Option>
            <Option value="12">12</Option>
          </Select>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={addRow}
          >
            Add
          </Button>
        </StyledDialogBody>
      </Dialog>
    </DarkThemeProvider>
  )
}

const StyledDialogBody = styled(DialogBody)`
  padding-bottom: ${(props) => props.theme.spacing[8]}!important;
`
